<template>
  <div class="booking-home">
    <div class="booking-header">
      <div @click="goPage('BookingList')">
        历史记录
      </div>
      <div
        class="booking-submit"
        @click="confirm"
      >
        完成
      </div>
    </div>
    <div class="booking-division" />
    <customer
      @change="customerChange"
      ref="customer"
    />
    <div class="booking-division" />

    <div
      class="booking-form"
      v-for="(item, index) in bookingInfoList"
      :key="index"
    >
      <div class="booking-division" />

      <van-field
        name="radio"
        input-align="right"
        label="付费方式"
        placeholder=""
      >
        <template #input>
          <van-radio-group
            checked-color="#DA0032"
            v-model="item.pay_type"
            direction="horizontal"
            @change="onPayTypeChange"
          >
            <van-radio
              v-for="option in allEnum.ApplyPayTypeArr"
              :key="option.value"
              :name="option.value"
            >{{ option.name }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-show="item.pay_type == 2"
        input-align="right"
        readonly
        clickable
        name="picker"
        :value="item.account_company_name"
        label="挂账公司"
        placeholder="点击选择挂账公司"
        @click="selectBillingCompany(item)"
      >
        <template #button>
          <div class="booking-form-select">
            <i class="el-icon-arrow-right"></i>
          </div>
        </template>
      </van-field>

      <van-field
        input-align="right"
        readonly
        clickable
        rows="1"
        autosize
        type="textarea"
        name="picker"
        :value="(item.customName || item.product_name || item.his_package_name)"
        label="产品名称"
        placeholder="点击选择产品"
        @click="openProductPicker(item)"
      >
        <template #button>
          <div class="booking-form-select">
            <i class="el-icon-arrow-right"></i>
          </div>
        </template>
      </van-field>

      <div
        class="booking-home-form-package"
        v-if="((item.product_type == 1 && item.projectList) || item.his_package_id)"
      >
        套餐包含：{{ item.projectList.join('+') }}

      </div>
      <van-field
        input-align="right"
        name="switch"
        label="是否需要定制"
      >
        <template #input>
          <van-switch
            inactive-color="#EAEAEA"
            active-color="#DA0032"
            :disabled="item.switchDisabled"
            :active-value="1"
            :inactive-value="0"
            v-model="item.is_custom"
            @change="switchChange"
            size="20"
          />
        </template>
      </van-field>
      <van-field
        name="switch"
        label="期望预约时间"
        input-align="right"
        @click="goPlan(item)"
      >
        <template #button>
          <div class="booking-form-select">
            {{ item.his_booking_time ? `${moment(item.his_booking_time).format('YYYY-MM-DD')} ${item.his_booking_begintime}-${item.his_booking_endtime}` : '请选择期望预约时间' }}<i class="el-icon-arrow-right"></i>
          </div>
        </template>

      </van-field>
      <van-field
        input-align="right"
        v-model="item.record_remark"
        name="备注"
        label="备注"
        type="textarea"
        placeholder=""
        class="booking-form-textarea-right"
      >
      </van-field>
      <div
        class="booking-home-more"
        v-if="index > 0"
        @click="bookingInfoList.pop()"
      >
        <van-icon name="clear" />
        删除
      </div>
      <div class="booking-division" />

    </div>

    <div class="booking-division" />
    <div
      v-show="bookingInfoList.length < 2"
      class="booking-home-more"
      @click="bookingInfoList.push({})"
    >
      <van-icon
        name="add"
        size="20px"
      />
      预约
    </div>
    <div class="booking-division" />

    <div
      v-show="!showMore"
      class="booking-home-more"
      @click="showMore = true"
    >
      更多
      <i class="el-icon-arrow-down"></i>
    </div>
    <div class="booking-division" />

    <div
      class="booking-form"
      v-show="showMore"
    >
      <!-- <van-field
        name="radio"
        input-align="right"
        label="部门"
        placeholder=""
      >
        <template #input>
          <van-radio-group
            checked-color="#DA0032"
            v-model="addForm.tijian_department"
            direction="horizontal"
          >
            <van-radio name="门诊部">门诊部</van-radio>
            <van-radio name="会员部">会员部</van-radio>
          </van-radio-group>
        </template>
      </van-field> -->
      <van-field
        name="radio"
        input-align="right"
        label="外送联系人"
        placeholder=""
      >
        <template #input>
          <van-radio-group
            checked-color="#DA0032"
            v-model="addForm.waisong_contact_type"
            direction="horizontal"
          >
            <van-radio
              v-for="option in allEnum.WaisongContactTypeArr"
              :key="option.value"
              :name="option.value"
            >{{ option.name }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-show="(addForm.waisong_contact_type == 3)"
        input-align="right"
        v-model="addForm.waisong_agent_phone"
        name="代理人电话"
        label="代理人电话"
        placeholder="请输入代理人电话"
      />
      <van-field
        input-align="right"
        name="switch"
        label="是否通知推荐人"
        label-width="120"
      >
        <template #input>
          <van-switch
            inactive-color="#EAEAEA"
            active-color="#DA0032"
            :active-value="1"
            :inactive-value="0"
            v-model="addForm.is_agent_notify"
            size="20"
          />
        </template>
      </van-field>
      <van-field
        v-show="addForm.is_agent_notify"
        input-align="right"
        v-model="addForm.agent_user_name"
        name="推荐人姓名"
        label="推荐人姓名"
        placeholder="请输入推荐人姓名"
        @blur="$forceUpdate()"
      >
        <template #input>
          <el-select
            popper-class="booking-form-select"
            :value="addForm.agent_user_name"
            filterable
            remote
            allow-create
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="remoteLoading"
            @change="agentChange"
            value-key="ReferralCode"
            @focus="onAgentSelectFocus"
            ref="agentSelect"
            @hook:mounted="cancalReadOnly"
            @visible-change="cancalReadOnly"
          >
            <el-option
              v-for="item in agentList"
              :key="item.ReferralCode"
              :label="item.ReferralName"
              :value="item"
            >
            </el-option>
          </el-select>
        </template>
      </van-field>
      <van-field
        v-show="addForm.is_agent_notify"
        input-align="right"
        v-model="addForm.agent_user_phone"
        name="推荐人手机"
        label="推荐人手机"
        type="tel"
        placeholder="请输入推荐人手机"
        @blur="$forceUpdate()"
      />

      <van-field
        v-show="levelUpInfo.valueAdded"
        input-align="right"
        name="switch"
        label="是否需要增值服务"
        label-width="120"
      >
        <template #input>
          <van-switch
            v-model="addForm.is_service"
            inactive-color="#EAEAEA"
            active-color="#DA0032"
            :active-value="1"
            :inactive-value="0"
            size="20"
            @change="isServiceChange"
          />
        </template>
      </van-field>

      <van-field
        name="checkboxGroup"
        label=""
        v-show="addForm.is_service"
      >
        <template #input>
          <van-checkbox-group
            v-model="addForm.service_list"
            direction="horizontal"
            @change="serviceListChange"
          >
            <van-checkbox
              name="1"
              shape="square"
              checked-color="#DA0032"
            >酒店服务</van-checkbox>
            <van-checkbox
              name="2"
              shape="square"
              checked-color="#DA0032"
            >礼宾服务</van-checkbox>
            <van-checkbox
              name="3"
              shape="square"
              checked-color="#DA0032"
            >停车服务</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <van-field
        v-if="addForm.parkingInfo"
        name="parking"
        label=""
      >
        <template #input>
          <div class="font-main">
            车牌号：{{  addForm.parkingInfo.car_no }} {{ addForm.parkingInfo.parking_no }}号车位 {{ addForm.parkingInfo.time_list.map(item => item.time).join(',') }}
          </div>
        </template>
      </van-field>
      <van-field
        input-align="right"
        name="switch"
        label="是否发送预约短信"
        label-width="120"
      >
        <template #input>
          <van-switch
            v-model="addForm.is_tijian_send_msg"
            inactive-color="#EAEAEA"
            active-color="#DA0032"
            :active-value="1"
            :inactive-value="0"
            size="20"
          />
        </template>
      </van-field>
      <el-upload
        action=""
        class="booking-home-upload"
        :auto-upload="false"
        :show-file-list="true"
        :http-request="() => {}"
        :on-change="onFileChanged"
        :on-remove="onFileRemove"
        :file-list="fileList"
        :before-upload="beforeUpload"
        :on-exceed="handleExceed"
        :limit="10"
        accept="image/jpeg,image/jpg,image/png"
        multiple
      >
        <el-button
          size="small"
          type="primary"
        ><i class="el-icon-upload el-icon--left"></i>上传付款凭证</el-button>
        <div
          slot="tip"
          class="el-upload__tip"
        >支持扩展名：.png.jpg.jpeg</div>
      </el-upload>

    </div>

    <el-dialog
      title=""
      :visible.sync="dialogShow"
      class="booking-collect-dialog"
      width="70%"
    >
      <div class="booking-home-dialog">
        <div class="booking-home-dialog-title">
          <i class="el-icon-warning-outline"></i> 提示
        </div>
        <div class="booking-home-dialog-content">
          客户{{ addForm.customer_name }}{{ levelUpInfo.levelRes }},客户等级由{{ addForm.customer_level }}升为{{ addForm.customer_temp_level }}
        </div>
      </div>

    </el-dialog>
    <van-popup v-model="customPricePicker">
      <div class="booking-custom">
        <van-field
          v-model="customPrice"
          label=""
          type="number"
          placeholder="请输入商保额度"
        />
        <div class="booking-custom-btn">
          <el-button
            size="mini"
            @click="customPriceCancel"
          >取消</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="customPriceConfirm"
          >确定</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showBillingCompanyPicker"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showBillingCompanyPicker = false">
            取消
          </div>
          <div
            class="booking-submit"
            @click="onCompanyConfirm"
          >
            完成
          </div>
        </div>
        <div class="booking-division" />

        <form action="/">
          <van-search
            v-model="searchForm.company"
            placeholder="请输入搜索关键词"
            show-action
            @search="onBillingCompanySearch"
          >
            <template #action>
              <div @click="onBillingCompanySearch(searchForm.company)">搜索</div>
            </template>
          </van-search>
        </form>
        <div class="booking-division" />

        <div class="booking-home-search-list">
          <div
            v-for="item in billingCompanyColumns"
            :key="item['公司ID']"
            class="booking-home-search-item"
            :class="{
                'booking-home-search-item-current': item.select
              }"
            @click="onCompanyChange(item)"
          >
            {{ item['公司名称'] }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showProductPicker"
      position="bottom"
    >
      <div class="booking-home-search">
        <div
          class="booking-home-search-header"
          @click="showProductPicker = false"
        >
          <div>
            取消
          </div>
          <div
            class="booking-submit"
            @click="onProductConfirm"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <form action="/">
          <van-search
            v-model="searchForm.product"
            placeholder="请输入搜索关键词"
            show-action
            @search="onProductSearch"
          >
            <template #action>
              <div @click="onProductSearch(addForm.product)">搜索</div>
            </template>
          </van-search>
        </form>
        <div class="booking-division" />

        <div class="booking-home-search-list">
          <div
            v-for="item in productColumns"
            :key="item.id"
            class="booking-home-search-item"
            :class="{
                'booking-home-search-item-current': item.select
              }"
            @click="onProductChange(item)"
          >
            {{ item.product_name }} {{ item.his_package_price }}元
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showPackagePicker"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showPackagePicker = false">
            取消
          </div>
          <div
            class="booking-submit"
            @click="onPackageConfirm"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <form action="/">
          <van-search
            v-model="searchForm.package"
            placeholder="请输入搜索关键词"
            show-action
            @search="onPackageSearch"
          >
            <template #action>
              <div @click="onPackageSearch(searchForm.package)">搜索</div>
            </template>
          </van-search>
        </form>
        <div class="booking-division" />

        <div class="booking-home-search-list">
          <div
            v-for="item in packageColumns"
            :key="item.tcID"
            class="booking-home-search-item"
            :class="{
                'booking-home-search-item-current': item.select
              }"
            @click="onPackageChange(item)"
          >
            {{ item.tcName }} {{ item.tcID == -1 || item.tcID == insuranceCompanyId ? '' : `${item.tcPrice ? item.tcPrice : ''}元` }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-overlay
      :show="uploading"
      :z-index="9999"
    >
      <van-loading size="24px">提交中...</van-loading>
    </van-overlay>
    <BookingParking
      ref="bookingParking"
      @confirm="parkingConfirm"
      @closed="parkingCancel"
    />
  </div>
</template>

<script>
import customer from "./components/customer.vue";
import BookingParking from "./components/parking.vue";
import enums from "@/views/booking/mixins/enums";
import bookingService from "@/apis/booking";
import { Toast } from "vant";
import { mapGetters } from "vuex";
import moment from "moment";
import { deepClone } from "@/utils/utils";
// import hisService from "@/apis/his/index";
import systemService from "@/apis/system/index.js";

const initForm = {
  service_list: [],
  tijian_department: "门诊部",
  is_custom: 0,
  is_agent_notify: 0,
  is_service: 0,
  waisong_contact_type: 1,
  is_tijian_send_msg: 1,
  agent_user_name: "",
  agent_user_phone: "",
  agent_user_code: "",
};
const initBookingInfoList = [
  {
    switchDisabled: true,
  },
];
const insuranceCompanyId = -5;

export default {
  components: {
    customer,
    BookingParking,
  },
  mixins: [enums],
  computed: {
    ...mapGetters(["planInfo"]),
  },
  watch: {
    bookingInfoList: {
      handler(newVal) {
        console.log(newVal);
      },
      deep: true,
    },
    planInfo: {
      handler(newVal) {
        const { addForm, currentBookingInfo, bookingInfoList } = this;

        // 重置 增值服务
        addForm.is_service = 0;
        if (bookingInfoList.every((item) => !item.is_service)) {
          addForm.service_list = [];
        }

        currentBookingInfo.his_booking_planid = newVal["体检人次ID"];
        currentBookingInfo.his_booking_time = newVal["预约日期"];
        currentBookingInfo.his_booking_begintime = newVal["开始时间"];
        currentBookingInfo.his_booking_endtime = newVal["截止时间"];
        currentBookingInfo.his_booking_tijian_planid = newVal["体检人次ID"];
        currentBookingInfo.his_booking_neijing_planid = newVal["内镜人次ID"];
        currentBookingInfo.his_booking_waisong_planid = newVal["磁共振人次ID"];
        this.addForm = {
          ...addForm,
        };
        this.$forceUpdate();
      },
      deep: true,
    },
    // currentUserInfo: {
    //   handler(newVal) {
    //     const { addForm } = this;
    //     if (newVal.ding_user_id) {
    //       addForm.agent_user_name = newVal.user_name;
    //       addForm.agent_user_phone = newVal.mobile;
    //       initForm.agent_user_name = newVal.user_name;
    //       initForm.agent_user_phone = newVal.mobile;
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "BookingSuccess") {
      next((vm) => {
        vm.init();
      });
    } else {
      next();
    }
  },
  data() {
    return {
      insuranceCompanyId,
      overlayShow: true,
      dialogShow: false,
      searchForm: {},
      addForm: deepClone(initForm),
      bookingInfoList: deepClone(initBookingInfoList),
      cuotomer: {},
      cuotomerList: [],
      cuotomerLoading: false,
      showPayTypePicker: false,
      payTypeColumns: [],

      showBillingCompanyPicker: false,
      billingCompanyColumns: [],
      currentSelectCompany: {},

      showProductPicker: false,
      productColumns: [],
      selectProduct: undefined,

      showPackagePicker: false,
      packageColumns: [],
      selectPackage: undefined,

      showMore: false,

      switchDisabled: true,

      uploading: false,
      levelUpInfo: {},

      customPricePicker: false,
      customPrice: null,

      fileList: [],
      currentBookingInfo: {},
      remoteLoading: false,
      agentList: [],
    };
  },
  created() {
    this.hisCustomerCompanySearch();
    this.getProductList();
    this.onPackageSearch();
    this.remoteMethod();
  },
  mounted() {
    // let initialWindowHeight = window.innerHeight;
    // console.log(this.$refs.agentSelect);
    // window.addEventListener("resize", () => {
    //   if (window.innerHeight < initialWindowHeight) {
    //     setTimeout(() => {
    //       document.querySelector(".el-scrollbar__wrap").style.minHeight =
    //         "100px";
    //       document.querySelector(".el-scrollbar__wrap").style.height = "100px";
    //       this.$refs.agentSelect.$forceUpdate();
    //     }, 300);
    //   } else {
    //     console.log("键盘收起了");
    //   }
    // });
  },
  methods: {
    moment,
    init() {
      this.addForm = deepClone(initForm);
      this.bookingInfoList = deepClone(initBookingInfoList);
      this.$refs.customer.init();
    },
    async confirm() {
      const { addForm, currentUserInfo, fileList, bookingInfoList } = this;

      if (this.uploading) return;
      let errMsg = "";
      if (!addForm.customer_empi) {
        errMsg = "请选择客户";
      } else if (
        addForm.waisong_contact_type == 3 &&
        !addForm.waisong_agent_phone
      ) {
        errMsg = "请输入代理人电话";
      } else if (addForm.is_service && addForm.service_list.length === 0) {
        errMsg = "请选择服务";
      }
      bookingInfoList.forEach((item) => {
        if (!item.pay_type) {
          errMsg = "请选择付费方式";
        } else if (item.pay_type == 2 && !item.account_company_id) {
          errMsg = "请选择挂账公司";
        } else if (!item.product_id && !item.his_package_id) {
          errMsg = "请选择产品";
        } else if (!item.his_booking_time) {
          errMsg = "请选择期望预约时间";
        } else if (
          addForm.customer_temp_level === "C" &&
          addForm.scrm_important_level === "C" &&
          item.is_custom === 1
        ) {
          errMsg = "C级客户不可选择定制套餐";
        }
      });

      if (addForm.is_agent_notify) {
        if (!addForm.agent_user_name) {
          errMsg = "请输入推荐人姓名";
        } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(addForm.agent_user_phone)) {
          errMsg = "请正确输入推荐人手机";
        }
      }

      if (errMsg) {
        Toast(errMsg);
        return;
      }
      if (!addForm.account_company_id) addForm.account_company_id = 0;
      if (addForm.his_package_id === insuranceCompanyId) {
        addForm.customer_temp_level = "A";
        addForm.customer_level = "A";
      }

      addForm.SubmitUserId = currentUserInfo.user_id;
      addForm.SubmitUser = currentUserInfo.user_name;
      addForm.SubmitUserPhone = currentUserInfo.mobile;

      this.uploading = true;

      try {
        if (addForm.is_agent_notify && !addForm.agent_user_code) {
          const addAgentInfo = await bookingService.hisAddReference({
            referral_name: addForm.agent_user_name,
          });
          if (addAgentInfo.Message) {
            Toast(addAgentInfo.Message);
            this.uploading = false;
            return;
          }
          addForm.agent_user_code = addAgentInfo;
        }
        const params = [];
        bookingInfoList.forEach((item) => {
          let paramsOption = {
            ...addForm,
            service_list: addForm.service_list.join(","),
            paymentVoucher: fileList.map((item) => item.file_url).join("|"),
            files: fileList,
            ...item,
          };
          if (addForm.parkingInfo) {
            paramsOption = {
              ...paramsOption,
              ...addForm.parkingInfo,
            };
          }

          params.push(paramsOption);
        });

        bookingService
          .applyAdd({
            list: params,
          })
          .then((res) => {
            this.uploading = false;
            if (res.Status === -1) {
              Toast(res.Message);
              return;
            }
            this.init();
            if (res.bind_qrcode_url) {
              this.$router.replace({
                name: "BookingQrCode",
                query: {
                  type: "apply",
                  id: res.id,
                  userId: this.currentUserInfo.user_id,
                },
              });
            } else {
              this.$router.replace({
                name: "BookingSuccess",
                query: {
                  type: "apply",
                  id: res.id,
                },
              });
            }
          })
          .catch(() => {
            this.uploading = false;
          });
      } catch (error) {
        this.uploading = false;
        return;
      }
    },
    customerChange(customerInfo) {
      this.addForm = deepClone(initForm);
      this.bookingInfoList = deepClone(initBookingInfoList);
      this.addForm.customer_empi = customerInfo.empi;
      this.addForm.customer_level = customerInfo.level;
      this.addForm.customer_name = customerInfo.name;
      this.addForm.customer_mobile = customerInfo.user_mobile;
      this.addForm.user_sex = customerInfo.user_sex;
    },
    goPlan(bookingInfo) {
      // const { addForm } = this;
      if (!bookingInfo.product_id && !bookingInfo.his_package_id) {
        Toast("请先选择产品");
        return;
      }
      this.currentBookingInfo = bookingInfo;
      this.$router.push({
        name: "BookingPlan",
        query: {
          neijingItemID: bookingInfo.neijingItemID,
          waiSongItemID: bookingInfo.waiSongItemID,
          his_package_id: bookingInfo.his_package_id,
          isCheckup: bookingInfo.isCheckup,
        },
      });
    },
    onBillingCompanySearch(query) {
      this.hisCustomerCompanySearch(query);
    },
    onPayTypeChange() {
      const { addForm } = this;

      addForm.account_company_id = undefined;
      addForm.account_company_name = undefined;
      if (addForm.pay_type == 2) {
        this.packageColumns = [];
      } else {
        this.getPackageList();
      }

      this.initProduct();
    },
    onCompanyChange(company) {
      const { billingCompanyColumns } = this;
      this.currentSelectCompany = company;

      billingCompanyColumns.forEach((item) => {
        item.select = false;
      });
      company.select = true;
      this.billingCompanyColumns = [...billingCompanyColumns];
    },
    onCompanyConfirm() {
      const { currentSelectCompany, currentBookingInfo } = this;
      if (!currentSelectCompany["公司ID"]) {
        Toast("请选择挂账公司");
        return;
      }
      currentBookingInfo.account_company_id = currentSelectCompany["公司ID"];
      currentBookingInfo.account_company_name =
        currentSelectCompany["公司名称"];
      this.showBillingCompanyPicker = false;
      currentBookingInfo.his_package_id = "";
      currentBookingInfo.his_package_name = "";
      this.getPackageList();
    },
    hisCustomerCompanySearch(query) {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        companyName: query,
      };
      bookingService.hisCustomerCompanySearch(params).then((res) => {
        this.billingCompanyColumns = res;
      });
    },
    onProductSearch(product_name = "") {
      this.getProductList(product_name);
    },
    onPayTypeConfirm() {},
    onBillingCompanyConfirm() {},
    remoteMethod(filter = "") {
      const params = {
        filter,
      };
      bookingService.hisReferenceList(params).then((res) => {
        this.agentList = res.map((i) => {
          return {
            ...i,
            ReferralName: `${i.ReferralName}(${i.ReferralType})`,
          };
        });
        console.log(res);
      });
    },
    onAgentSelectFocus(e) {
      console.log(e);
    },
    agentChange(value) {
      console.log(value);
      if (typeof value === "string") {
        this.addForm.agent_user_name = value;
        this.addForm.agent_user_code = undefined;
      } else {
        this.addForm.agent_user_name = value.ReferralName;
        this.addForm.agent_user_code = value.ReferralCode;
      }

      this.addForm.agent_user_phone = "";
      this.$forceUpdate();
    },
    selectChange() {},
    getProductList(product_name = "") {
      const params = {
        product_type: "1,2",
        product_name,
        page_index: 1,
        page_size: 9999,
      };
      bookingService.productList(params).then((res) => {
        this.productColumns = res.data;
      });
    },
    onProductChange(option) {
      const { productColumns } = this;
      productColumns.forEach((item) => {
        item.select = false;
      });
      option.select = true;
      this.selectProduct = option;
      this.productColumns = [...productColumns];
    },
    onProductConfirm() {
      const { selectProduct, addForm } = this;
      if (!selectProduct) {
        Toast("请选择产品");
        return;
      }
      this.initProduct();

      const projectList = [];
      addForm.product_id = selectProduct.id;
      addForm.product_name = selectProduct.product_name;
      addForm.product_type = selectProduct.product_type;
      addForm.product_price = selectProduct.product_price;
      addForm.neijingItemID = selectProduct.neijingItemID;
      addForm.waiSongItemID = selectProduct.waiSongItemID;
      addForm.his_package_id = selectProduct.his_package_id;

      if (addForm.his_package_id != 0 && addForm.his_package_id) {
        projectList.push("院内体检");
      }
      if (addForm.neijingItemID) {
        projectList.push("胃肠镜");
      }
      if (addForm.waiSongItemID) {
        projectList.push("外送");
      }
      addForm.projectList = selectProduct.product_combi.split("+");
      this.showProductPicker = false;
      this.hisCustomerLevelTmpCal();
    },
    initProduct() {
      const { addForm } = this;

      // 重置 增值服务
      addForm.is_service = 0;
      addForm.service_list = [];

      // 重置产品
      addForm.product_id = 0;
      addForm.product_name = undefined;
      addForm.product_type = undefined;
      addForm.product_price = undefined;
      addForm.neijingItemID = undefined;
      addForm.waiSongItemID = undefined;
      addForm.his_package_id = undefined;

      addForm.customName = undefined;

      // 重置套餐
      addForm.his_package_id = undefined;
      addForm.his_package_name = undefined;
      addForm.his_package_price = undefined;
      addForm.neijingItemID = undefined;
      addForm.neijingItem = undefined;
      addForm.waiSongItemID = undefined;
      addForm.waiSongItem = undefined;

      // 重置预约时间
      addForm.his_booking_planid = "";
      addForm.his_booking_time = "";
      addForm.his_booking_begintime = "";
      addForm.his_booking_endtime = "";
      addForm.his_booking_tijian_planid = "";
      addForm.his_booking_neijing_planid = "";
      addForm.his_booking_waisong_planid = "";
      addForm.is_custom = 0;

      this.$forceUpdate();
    },
    onPackageSearch(tcName = "") {
      this.getPackageList(tcName);
    },
    getPackageList(tcName = "") {
      const { addForm, currentBookingInfo } = this;
      const params = {
        tcID: "",
        tcName,
        pageNo: 1,
        companyID: currentBookingInfo.account_company_id
          ? currentBookingInfo.account_company_id
          : 0,
        // pageSize: tcName || addForm.account_company_id ? 9999 : 5,
        pageSize: 9999,
        tcSex: addForm.user_sex,
        PaymentMethod: addForm.pay_type,
      };
      this.packageColumns = [];
      bookingService.hisPackageSearch(params).then((res) => {
        res.forEach((item) => {
          // 标记体检套餐
          if (
            item.tcID != -2 &&
            item.tcID != 0 &&
            item.tcID != -3 &&
            item.tcID != -4
          ) {
            item.isCheckup = true;
          }
        });
        this.packageColumns = res;
      });
    },
    onPackageChange(option) {
      const { packageColumns } = this;
      packageColumns.forEach((item) => {
        item.select = false;
      });
      option.select = true;
      this.selectPackage = option;
      this.packageColumns = [...packageColumns];
    },
    onPackageConfirm() {
      const { selectPackage, customPrice, currentBookingInfo } = this;
      if (!selectPackage) {
        Toast("请选择套餐");
        return;
      }
      if (selectPackage.tcID === insuranceCompanyId && !customPrice) {
        this.customPricePicker = true;
        return;
      }

      const projectList = [];
      this.initProduct();

      currentBookingInfo.product_id = 0;
      currentBookingInfo.his_package_id = selectPackage.tcID;
      currentBookingInfo.his_package_name = selectPackage.tcName;
      currentBookingInfo.his_package_price = selectPackage.tcPrice;
      currentBookingInfo.neijingItemID = selectPackage.neijingItemID;
      currentBookingInfo.neijingItem = selectPackage.neijingItem;
      currentBookingInfo.waiSongItemID = selectPackage.waiSongItemID;
      currentBookingInfo.waiSongItem = selectPackage.waiSongItem;
      currentBookingInfo.isCheckup = selectPackage.isCheckup;
      currentBookingInfo.is_custom = 0;

      // 特殊套餐处理
      if (currentBookingInfo.his_package_id == -1)
        currentBookingInfo.is_custom = 1;

      if (selectPackage.tcID === insuranceCompanyId) {
        currentBookingInfo.is_custom = 1;
        currentBookingInfo.his_package_price = customPrice;
        currentBookingInfo.customName = `${selectPackage.tcName} (${customPrice}元)`;
      }

      // 重置预约时间
      if (currentBookingInfo.isCheckup) {
        projectList.push("院内体检");
      }

      if (
        (currentBookingInfo.neijingItem &&
          currentBookingInfo.neijingItem.indexOf("胃镜") !== -1 &&
          currentBookingInfo.neijingItem &&
          currentBookingInfo.neijingItem.indexOf("肠镜") !== -1) ||
        (currentBookingInfo.his_package_name &&
          currentBookingInfo.his_package_name.indexOf("胃肠镜") !== -1)
      ) {
        projectList.push("胃肠镜");
      } else if (
        currentBookingInfo.neijingItem &&
        currentBookingInfo.neijingItem.indexOf("胃镜") !== -1
      ) {
        projectList.push("胃镜");
      } else if (
        currentBookingInfo.neijingItem &&
        currentBookingInfo.neijingItem.indexOf("肠镜") !== -1
      ) {
        projectList.push("肠镜");
      }
      if (currentBookingInfo.waiSongItemID) {
        projectList.push("外送");
      }
      currentBookingInfo.projectList = projectList;
      this.showPackagePicker = false;
      this.hisCustomerLevelTmpCal();
      this.customPrice = null;
    },

    hisCustomerLevelTmpCal() {
      const { addForm, bookingInfoList } = this;
      const params = {
        EMPI: addForm.customer_empi,
        mealPrice: bookingInfoList.reduce(
          (accumulator, item) =>
            accumulator + (item.product_price || item.his_package_price),
          0
        ),
      };
      bookingService.hisCustomerLevelTmpCal(params).then((res) => {
        if (res[0]) {
          addForm.customer_temp_level = res[0].levelNanme;
          this.levelUpInfo = res[0];
          // currentBookingInfo.switchDisabled = true;
          bookingInfoList.forEach((item) => {
            item.switchDisabled = true;
            if (
              (item.product_type == 1 || item.his_package_id) &&
              (addForm.customer_temp_level < "C" ||
                addForm.customer_level < "C")
            ) {
              item.switchDisabled = false;
            }
            if (item.product_type == 2) {
              item.is_custom = 1;
              item.switchDisabled = false;
            }
          });
          this.$forceUpdate();

          if (addForm.customer_temp_level < addForm.customer_level) {
            this.dialogShow = true;
          }
        }
      });
    },
    switchChange() {
      this.$forceUpdate();
    },
    openProductPicker(bookingInfo) {
      const { addForm } = this;
      let errMsg = "";
      this.customPrice = null;
      if (!addForm.customer_empi) {
        errMsg = "请先选择客户";
      } else if (!bookingInfo.pay_type) {
        errMsg = "请先选择付费方式";
      } else if (bookingInfo.pay_type == 2 && !bookingInfo.account_company_id) {
        errMsg = "请先选择挂账公司";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }

      this.currentBookingInfo = bookingInfo;
      this.showPackagePicker = true;

      // if (addForm.pay_type == 1) {
      //   this.showProductPicker = true;
      // } else {
      //   this.showPackagePicker = true;
      // }
    },
    selectBillingCompany(bookingInfo) {
      this.currentBookingInfo = bookingInfo;
      this.showBillingCompanyPicker = true;
    },
    customPriceCancel() {
      this.customPrice = null;
      this.customPricePicker = false;
    },
    customPriceConfirm() {
      if (!/^\d+(\.\d{1,2})?$/.test(this.customPrice)) {
        Toast("请输入正确的商保额度");
        return;
      }
      this.customPricePicker = false;
      this.onPackageConfirm();
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { agentSelect } = this.$refs;
          const input = agentSelect.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    goPage(name) {
      this.$router.push({
        name,
      });
    },
    isServiceChange(value) {
      const { addForm, bookingInfoList } = this;
      if (value) {
        if (
          bookingInfoList.some((item) =>
            moment(item.his_booking_time).isBefore(
              moment().add(2, "days"),
              "day"
            )
          )
        ) {
          Toast("增值服务需要提前2日申请");
          addForm.is_service = 0;
        }
      }
      if (!value) {
        this.addForm.parkingInfo = null;
        this.addForm.service_list = [];
      }
    },
    onFileChanged(file, fileList) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.fileList = fileList;

      // const reader = new FileReader();
      // console.log(file);
      // reader.onload = (event) => {
      //   const base64Data = event.target.result;
      //   const params = {
      //     pe_no: "Circle_Health_761C12E9",
      //     report: "",
      //     Base64Str: base64Data.replace(/^data:image\/\w+;base64,/, ""),
      //   };

      //   hisService.uploadFile(params).then((res) => {
      //     file.file_name = res;
      //     this.systemServiceUpload(file, fileList);
      //   });
      // };

      // reader.readAsDataURL(file.raw);
      this.systemServiceUpload(file, fileList);
    },
    systemServiceUpload(file) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      const formData = new FormData();
      formData.append("file", file.raw);
      const query = {
        file_type: "work",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };

      systemService.upload(formData, query, onUploadProgress).then((res) => {
        file.file_id = res.file_id;
        file.file_url = res.url;
        file.status = "success";
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    serviceListChange(value) {
      const { addForm, bookingInfoList } = this;
      if (value.includes("3") && !addForm.parkingInfo) {
        this.$refs.bookingParking.handleParking({
          dateList: bookingInfoList.map((item) =>
            moment(item.his_booking_time).format("YYYY-MM-DD")
          ),
          user_name: addForm.customer_name,
          mobile: addForm.customer_mobile,
        });
      }
      console.log(value);
    },
    parkingConfirm(parkingInfo) {
      this.addForm.parkingInfo = parkingInfo;
      this.$forceUpdate();
    },
    parkingCancel() {
      const { addForm } = this;
      addForm.service_list = addForm.service_list.filter((item) => item != "3");
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-home {
  padding-bottom: 20px;
}
.booking-home-more {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  i {
    margin: 0 5px;
  }
}
.booking-home-form-package {
  padding: 15px 20px;
  background: rgba(0, 48, 87, 0.2);
  color: #003057;
}
.booking-home-dialog-title {
  text-align: center;

  color: #040000;
  font-weight: 500;
  font-size: 18px;
}
.booking-home-dialog-content {
  font-size: 15px;
  margin-top: 20px;
  line-height: 23px;
  color: #040000;
  font-weight: normal;
}
.booking-custom {
  padding: 15px 20px;
  .booking-custom-btn {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}
.font-main {
  color: #040000;
}
</style>
<style lang="scss">
.customer-select {
  .el-select-dropdown__item {
  }
}
.cuotomer-level {
  .el-form-item__content {
    display: flex;
    flex-direction: column;
  }
}
.cuotomer-level-trip {
  color: red;
  font-size: 12px;
  line-height: 14px;
}
.booking-home-upload {
  padding: 0 20px;
  .el-upload-list__item-name {
    color: #000;
  }
}
.booking-form-textarea-right {
  .van-field__control--right {
    text-align: left;
  }
}
.booking-home {
  .van-cell {
    .el-input__inner {
      text-align: right;
      background-color: transparent;
      border: none;
      padding: 0;
      color: #000;
    }
  }
}
.booking-form-select {
  .el-scrollbar__wrap {
    min-height: 130px;
    max-height: 130px;
  }
}
</style>